import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getWhiteLabelName } from "store/whiteLabel/selectors";
import { useFindOrFetchTeam } from "domain/team/hook/useFindOrFetchTeam";

function useDocumentTitle(teamId) {
  const whiteLabelName = useSelector(getWhiteLabelName);
  const [team] = useFindOrFetchTeam(teamId);

  useEffect(() => {
    if (!team) {
      document.title = whiteLabelName || "GetSales.io";
    } else {
      document.title = `#${teamId} ${team?.name}`;
    };
  }, [team?.id, team?.name]);
}

export default useDocumentTitle;
